/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for IesResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, IesViewDTO, TypeIesDto } from "../models";

@Injectable({ providedIn: "root" })
export class IesResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findAllIES(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<IesViewDTO>>;
    findAllIES(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<IesViewDTO>>>;
    findAllIES(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<IesViewDTO>>>;
    findAllIES(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addIes(ies: string, file?: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<IesViewDTO>;
    addIes(ies: string, file?: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<IesViewDTO>>;
    addIes(ies: string, file?: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<IesViewDTO>>;
    addIes(ies: string, file?: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }
        if (ies !== undefined) {
            formData.append('ies', String(ies));
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateIes(ies: string, file?: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<IesViewDTO>;
    updateIes(ies: string, file?: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<IesViewDTO>>;
    updateIes(ies: string, file?: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<IesViewDTO>>;
    updateIes(ies: string, file?: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }
        if (ies !== undefined) {
            formData.append('ies', String(ies));
        }

        return this.httpClient.request('put', url, {
            body: formData,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    notifyIes(id: number, observe?: 'body', options?: RequestOptions<'text'>): Observable<boolean>;
    notifyIes(id: number, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<boolean>>;
    notifyIes(id: number, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<boolean>>;
    notifyIes(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies/notify/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    achiveIes(id: number, motif: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<boolean>;
    achiveIes(id: number, motif: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<boolean>>;
    achiveIes(id: number, motif: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<boolean>>;
    achiveIes(id: number, motif: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies/archive/${id}`;

        let params = new HttpParams();
        if (motif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motif, 'motif');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getIesById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<IesViewDTO>;
    getIesById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<IesViewDTO>>;
    getIesById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<IesViewDTO>>;
    getIesById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllTypeIes(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TypeIesDto>>;
    findAllTypeIes(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TypeIesDto>>>;
    findAllTypeIes(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TypeIesDto>>>;
    findAllTypeIes(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/ies/types`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
